
import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as FacebookSVG } from './facebook-messenger-brands.svg';

export default function MessengerIcon({style}){
    return <div><FacebookSVG style={style}/></div>
}